import React from 'react';
import { Hourglass } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * Dim/blur wrapper for features that are coming soon.
 */
export default function FeatureOverlay({
  visible = true,
  title = 'Coming Soon',
  subtitle = 'This feature is under development.',
  blur = false,
  className,
  children,
}) {
  if (!visible) return children;

  return (
    <div className={cn('relative', className)}>
      <div className={cn('pointer-events-none select-none opacity-60', blur && 'blur-[1.5px]')} aria-hidden="true">
        {children}
      </div>

      <div className="absolute inset-0 z-10 flex flex-col items-center justify-center rounded-xl bg-ink/40 text-center p-4">
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 border border-primary/30 mb-2">
          <Hourglass className="w-3.5 h-3.5 text-primary" />
          <span className="text-xs font-semibold uppercase tracking-wide text-primary">{title}</span>
        </div>
        {subtitle && <p className="text-xs text-muted max-w-xs leading-relaxed">{subtitle}</p>}
      </div>
    </div>
  );
}
